var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{style:(("opacity:" + (_vm.isLoaded ? 1 : 0))),attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":function($event){return _vm.setImageLoaded()}}})}
var staticRenderFns = []

export { render, staticRenderFns }